import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex flex-row items-start gap-2" }
const _hoisted_2 = { class: "w-full" }
const _hoisted_3 = {
  key: 0,
  class: "mt-4 text-sm"
}

import { UiTag } from '@klausapp/ui-kit'
import { delay } from '@/components/Tippy'


export default /*@__PURE__*/_defineComponent({
  __name: 'ButtonCard',
  props: {
    title: {},
    description: {},
    tooltip: {},
    active: { type: Boolean },
    disabled: { type: Boolean },
    isComingSoon: { type: Boolean },
    smallPadding: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _directive_tippy = _resolveDirective("tippy")!

  return _withDirectives((_openBlock(), _createElementBlock("button", {
    type: "button",
    "data-testid": "button-card-label",
    class: _normalizeClass(["flex flex-1 rounded-lg border-2", [
      _ctx.active && !_ctx.disabled ? 'border-zblue-60' : 'border-gray-30',
      _ctx.disabled && 'cursor-not-allowed',
      _ctx.smallPadding ? 'p-3' : 'p-4',
      _ctx.isComingSoon ? 'bg-gray-20' : 'bg-white',
      !_ctx.disabled ? 'hover:bg-zblue-10 hover:border-zblue-60' : '',
    ]])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass(["mb-1 flex min-h-6 items-center gap-2 text-sm font-medium", _ctx.disabled ? 'text-gray-50' : 'text-gray-80'])
        }, [
          _createTextVNode(_toDisplayString(_ctx.title) + " ", 1 /* TEXT */),
          (_ctx.isComingSoon)
            ? (_openBlock(), _createBlock(_unref(UiTag), {
                key: 0,
                theme: "blue"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('settings.coming_soon')), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }))
            : _createCommentVNode("v-if", true)
        ], 2 /* CLASS */),
        _createElementVNode("div", {
          "data-testid": "button-card-description",
          class: _normalizeClass(["flex text-left text-xs font-normal", _ctx.disabled ? 'text-gray-50' : 'text-gray-60'])
        }, _toDisplayString(_ctx.description), 3 /* TEXT, CLASS */),
        (_ctx.$slots.additionalContent)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _renderSlot(_ctx.$slots, "additionalContent")
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ])
  ], 2 /* CLASS */)), [
    [_directive_tippy, { content: _ctx.tooltip ? _ctx.tooltip : null, placement: 'top', delay: _unref(delay) }]
  ])
}
}

})